import {
    OpeningHoursButtonStyled,
    OpeningHoursRowStyled,
    OpeningHoursTableStyled,
    OpeningHoursTableTypeProps,
} from './OpeningHoursTable.style';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { ArrowIcon } from 'public/svg/IconsSvg';
import { useState } from 'react';
import { OpeningHours } from 'types/openingHours';

export type OpeningHoursDayProps = {
    status: 'open' | 'closed' | 'default';
};

type OpeningHoursTableProps = OpeningHours &
    OpeningHoursTableTypeProps & { isCollapsed?: boolean; shortDayNames?: boolean };

const OpeningHoursTable: FC<OpeningHoursTableProps> = (props) => {
    const testIdentifier = 'block-openinghours';
    const t = useTypedTranslationFunction();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(props.isCollapsed ?? false);

    const dayNames = [
        t('Monday'),
        t('Tuesday'),
        t('Wednesday'),
        t('Thursday'),
        t('Friday'),
        t('Saturday'),
        t('Sunday'),
    ];

    const formatDayTime = (time: string) => time.replace(/^0(?=[1-9])/, '');

    const formatDayName = (day: string) => (props.shortDayNames ? day.substring(0, 2) : day);

    const getOpeningStatusOfDayByIndex = (index: number): OpeningHoursDayProps => {
        const { isCurrentlyOpen, currentDayOfTheWeek } = props;

        if (currentDayOfTheWeek === index) {
            return isCurrentlyOpen ? { status: 'open' } : { status: 'closed' };
        }

        if (currentDayOfTheWeek !== index) {
            const day = props.days[index];

            return day.intervals.length === 0 ? { status: 'closed' } : { status: 'default' };
        }

        return { status: 'default' };
    };

    return (
        <OpeningHoursTableStyled type={props.type} data-testid={testIdentifier}>
            <tbody>
                {props.days.slice(0, isCollapsed ? 2 : props.days.length).map(({ dayOfTheWeek, intervals }, index) => (
                    <OpeningHoursRowStyled key={index} {...getOpeningStatusOfDayByIndex(index)}>
                        <th>{formatDayName(dayNames[dayOfTheWeek])}</th>
                        <td>
                            {intervals.length > 0 &&
                                intervals.map(({ opening, closing }, index) => (
                                    <div key={index}>{`${formatDayTime(opening)} – ${formatDayTime(closing)}`}</div>
                                ))}
                            {intervals.length === 0 && <div>{t('Closed')}</div>}
                        </td>
                    </OpeningHoursRowStyled>
                ))}
                {isCollapsed && (
                    <tr>
                        <th colSpan={2}>
                            <OpeningHoursButtonStyled onClick={() => setIsCollapsed(false)}>
                                <span>{t('Show whole week')}</span> <ArrowIcon className="w-3" />
                            </OpeningHoursButtonStyled>
                        </th>
                    </tr>
                )}
            </tbody>
        </OpeningHoursTableStyled>
    );
};

export default OpeningHoursTable;
